"use strict";
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
const CLASS = `${prefix}-button-component`;
const Button = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped
    'data-tid': dataTid } = props, 
    // pass all other props to Carbon Button
    otherBottonProps = tslib_1.__rest(props, ['data-tid']);
    const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS);
    return (react_1.default.createElement(carbon_components_react_1.Button, Object.assign({ "data-tid": mappedDataTid, ref: ref, 
        // The version of Carbon that we have will dump the tooltip
        // directly on top of the button if not given the two props
        // tooltipAlignment and tooltipPosition. Until we upgrade
        // we will be defaulting the tooltips position, which may
        // cause tooltip visibility bugs, but better than overlapping.
        tooltipAlignment: "center", tooltipPosition: "bottom" }, otherBottonProps)));
});
Button.propTypes = carbon_components_react_1.Button.propTypes;
Button.defaultProps = carbon_components_react_1.Button.defaultProps;
exports.default = Button;
